__turbopack_context__.v({
  "app-store-reviews": "JtqVVW_app-store-reviews",
  "appStoreReviews": "JtqVVW_appStoreReviews",
  "author": "JtqVVW_author",
  "content": "JtqVVW_content",
  "description": "JtqVVW_description",
  "rating": "JtqVVW_rating",
  "rating-wrapper": "JtqVVW_rating-wrapper",
  "repeat-user": "JtqVVW_repeat-user",
  "root": "JtqVVW_root",
  "title": "JtqVVW_title",
  "user-reviews": "JtqVVW_user-reviews",
  "userReview": "JtqVVW_userReview",
});
